import React from "react";
import styles from "./VersionNumber.module.scss";
import { digitsToHindi } from "@bale/utils";
import { BaleLogo } from "@bale/ui";
import { strings } from "../../../intl/fa";

const VersionNumber: React.FC<React.PropsWithChildren<unknown>> = () => {
  const appVersion = digitsToHindi(String(process.env.BUILD_NUMBER));
  return (
    <div className={styles.Container}>
      <div className={styles.Wrapper}>
        <BaleLogo size={24} />
        <p className={styles.Message}>{strings.developed_by_bale}</p>
      </div>
      <p className={styles.Version}>{`نسخه (${appVersion})`}</p>
    </div>
  );
};

export default VersionNumber;
